module.exports = __webpack_public_path__ + "img/promotion_2.1db567ac.png";